import React from "react";

import { BaseComponent } from "shared/components";

/**
 *
 * @param choices list of choices
 * @param choicesStream should be a promise
 */
function withBaseSelect(choices, choicesStream = undefined, noReset = false) {
    return class extends BaseComponent {
        constructor(props) {
            super(props);
            this.defaultValue = props.value ? props.value : "";
            this.label = props.label ? props.label : "";
            this.state = {
                value: this.defaultValue,
                values: choices,
                noReset: noReset
            };

            this.onChange = this.onChange.bind(this);
            this.resetState = this.resetState.bind(this);
        }

        async componentDidMount() {
            if (choicesStream) {
                await choicesStream((values) => {
                    this.setState({ values });
                });
            }

            const value = this.state.values.find((v) => v.value === this.props.value)?.value;
            this.setState({ value });
        }

        componentDidUpdate(prevProps) {
            const { values } = this.state;
            if (this.props.value !== prevProps.value) {
                // find value by value
                const value = values.find((v) => v.value === this.props.value)?.value;
                this.setState({ value });
            }
        }

        onChange(event) {
            const value = event.target.value;
            this.setState({ value });

            if (this.props.onChange) {
                this.props.onChange(event);
            }
        }

        resetState() {
            if (!this.state.noReset) {
                this.setState({ value: "" });
            }
        }

        render() {
            const { value, values } = this.state;
            const { id, name, className } = this.props;
            return (
                <div className="field">

                    <label className="label">{this.label}</label>

                    <div className={`select is-fullwidth ${className}`}>
                        <select id={id} name={name} value={value} onChange={this.onChange}>
                            <option value=""></option>
                            {values.map((v) => (
                                <option key={v.value} value={v.value} selected={v.value === value}>{v.label}</option>
                            ))}
                        </select>
                    </div>

                </div>
            );
        }
    }
}

export default withBaseSelect;
